import { initCookiePreferencesTrigger } from "./cookie-preferences-trigger.js";
import { initSubMenuFooterMobToggling } from "./sub-menu-footer-mob-toggling.js";
import { initStickyHeader } from "./sticky-header.js";
import { initMobileMenu } from "./mobile-menu.js";
import { initSubmenuToggle } from "./main-menu-submenu.js";
import { initScrollAnimations } from "./scroll-animate.js";

export function initGeneral() {
	initCookiePreferencesTrigger();
	initSubMenuFooterMobToggling();
    initStickyHeader();
    initMobileMenu();
    initSubmenuToggle();
    initScrollAnimations();
}
